import {
  getParkingSessionByCamera,
  getParkingSessionPhoto,
  ParkingSessionPhotoType,
  ParkingSessionResultType,
} from "api/query/ParkingSession";
import { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Row, SectionContainer } from "../ui/grid";
import Title from "../ui/title/Title";
import styles from "../SessionConfirmation/SessionConfirmationPage.module.scss";
import Layout from "../layout";
import { LoaderCircle } from "../payment/loader/LoaderCircle";

const CameraConfirmationPage = () => {
  const navigate = useNavigate();
  const { zone, cameraId } = useParams();

  const [sessionState, setSessionState] = useState<ParkingSessionResultType>();
  const [photo, setPhoto] = useState<ParkingSessionPhotoType>();
  const [redirectToGrz, setRedirectToGrz] = useState(false);

  useEffect(() => {
    getParkingSessionByCamera(zone, cameraId).then((data) => {
      const session = (data.result || [])[0];
      if (session?.sessionID) {
        setSessionState(session);
      } else {
        setRedirectToGrz(true);
      }
    });
  }, [zone, cameraId]);

  useEffect(() => {
    if (!sessionState?.sessionID) return;
    getParkingSessionPhoto(zone, sessionState.sessionID).then((data) => {
      if (data?.result) {
        setPhoto(data);
      } else {
        setRedirectToGrz(true);
      }
    });
  }, [zone, sessionState?.sessionID]);

  useEffect(() => {
    if (redirectToGrz && zone) {
      navigate(`/${zone}/grz`, { replace: true });
    }
  }, [redirectToGrz, zone, navigate]);

  if (!sessionState || !photo) {
    return (
      <Layout>
        <SectionContainer fixHeight>
          <div className={styles.container}>
            <LoaderCircle />
          </div>
        </SectionContainer>
      </Layout>
    );
  }

  const paymentParams = new URLSearchParams();
  if (sessionState.grz) paymentParams.append("grz", sessionState.grz);
  const paymentLink = `/${zone}/session/${sessionState.sessionID}/payment${paymentParams.toString() ? `?${paymentParams.toString()}` : ""}`;
  return (
    <Layout>
      <SectionContainer fixHeight>
        <div className={styles.container}>
          <Title text="Это ваш автомобиль?" />
          <div className={styles.auto}>
            <div className={styles.img_container}>
              <img src={`data:image/png;base64, ${photo.result}`} alt="" />
            </div>
            <div className={styles.auto_info}>
              <span>{sessionState.date.split("T")[0]}</span>
              <span>{sessionState.date.split("T")[1]}</span>
            </div>
          </div>
          <div className={styles.btns}>
            <Row spaceBetween nowrap>
              <NavLink className={styles.btn} to={`/${zone}/grz`}>
                Нет
              </NavLink>
              <NavLink className={styles.btn} to={paymentLink}>
                Да
              </NavLink>
            </Row>
          </div>
        </div>
      </SectionContainer>
    </Layout>
  );
};

export default CameraConfirmationPage;
